import {
  LibraryNavigationMenu,
  LibraryNavigationMenuDisplayList,
  LibraryNavigationMenuText,
} from '@diritto/common/navigation/constant';
import styled from '@emotion/styled';
import { ContentBodyPadding, GNBSubMenuHeight, MaxContentBodySize } from 'constants/layout';
import { MyNavigationMenuPath } from 'constants/navigation';
import { LineSubMenu } from 'ui-components/navigations/LineSubMenu';

export const MyNavigationBar = ({ selectedMenu }: { selectedMenu: LibraryNavigationMenu }) => (
  <StyledContainer>
    <StyledSubMenu
      menuList={LibraryNavigationMenuDisplayList}
      menuPath={MyNavigationMenuPath}
      menuText={LibraryNavigationMenuText}
      selectedMenu={selectedMenu}
    />
  </StyledContainer>
);

const StyledContainer = styled.div`
  width: 100%;
  height: ${GNBSubMenuHeight}px;
  position: relative;
  display: flex;
  padding: 0 ${ContentBodyPadding}px;
  max-width: ${MaxContentBodySize}px;
`;

const StyledSubMenu = styled(LineSubMenu)``;
